import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

export default () => ({
    autoplay: false,
    delay: 7000,
    carousel: null,
    activeIndex: 0,
    isPlaying: false,
    isTiming: false,
    slides: [],

    init() {
        if (this.$refs.container.children.length > 1) {
            this.carousel = EmblaCarousel(this.$el, { loop: true }, [
                Autoplay({ playOnInit: false, delay: this.delay }),
            ])

            const onInit = () => (this.slides = this.carousel.slideNodes())

            this.carousel.on('init', onInit)
            this.carousel.on('reInit', onInit)
            this.carousel.on('autoplay:play', () => (this.isPlaying = true))
            this.carousel.on('autoplay:stop', () => (this.isPlaying = false))
            this.carousel.on('autoplay:timerset', () => (this.isTiming = true))
            this.carousel.on(
                'autoplay:timerstopped',
                () => (this.isTiming = false)
            )
            this.carousel.on('select', () => {
                const activeIndex = this.carousel.selectedScrollSnap()
                const activeSlide = this.carousel.slideNodes()[activeIndex]

                this.activeIndex = activeIndex
                this.$dispatch('carousel-change', { activeSlide })
            })

            if (this.autoplay) {
                this.carousel.plugins()?.autoplay.play()
            }
        }
    },

    previous() {
        this.carousel.scrollPrev()
    },

    next() {
        this.carousel.scrollNext()
    },

    goTo(index) {
        this.carousel.scrollTo(index)
    },
})
